export default __webpack_public_path__ + "50d6f9334619049e262431f7b1ed7aec.svg";